import articles from './articles'
import cashback from './cashback'
import faqs from './faqs'
import rates from './rates'
import users from './users'
import api from './api'

export default {
    api,
    cashback,
    users,
    rates,
    articles,
    faqs
}